// extracted by mini-css-extract-plugin
export var label = "_d1-5";
export var slideContainer = "_d1-0";
export var slider = "_d1-1";
export var sliderLg = "_d1-4";
export var sliderMd = "_d1-3";
export var sliderSm = "_d1-2";